"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var TableHeader = _styledComponents["default"].thead.attrs(function () {
  return {
    id: "best-table-header"
  };
}).withConfig({
  displayName: "TableHeader",
  componentId: "sc-2tpy6q-0"
})(["&&&{background-color:#f7f7f7;th{border:none;}}"]);

var _default = TableHeader;
exports["default"] = _default;